import { Box, Chip, Stack, Typography } from '@mui/material'
import { FilePickerButton } from 'components/Buttons/FilePickerButton'
import { PageSection } from 'components/PageSection'
import { FileTag, Maybe } from 'generated/graphql'
import { useSolicitationRole } from 'hooks/useSolicitationRole'
import { filter } from 'lodash'
import { useState } from 'react'
import { FileContent } from 'use-file-picker/dist/interfaces'

import { DocumentsTable } from '../DocumentsTable'
import { ReportsTable } from '../ReportsTable'
import { DocumentManagerReturn } from '../state/useDocumentManagerState'

export interface Props extends DocumentManagerReturn {
  generateReport: (id: string) => Promise<unknown>
  deleteFile: (fileId: string, proposalId?: string) => Promise<boolean>
  editFile: (id: string, name: string, tag?: Maybe<FileTag>) => Promise<boolean>
  onFilesSelected: (fileContent: FileContent[]) => void
}

export const Page = ({
  reportsTableData,
  documentsTableData,
  generateReport,
  deleteFile,
  editFile,
  onFilesSelected,
  solicitation,
}: Props): JSX.Element => {
  const [filterState, setFilterState] = useState<FileTag | undefined>()

  const { isConsensus } = useSolicitationRole(solicitation)

  const inlineLeftChildren = () => (
    <Stack direction="row" spacing={1} display="flex">
      {filterState === undefined ? (
        <SelectedChip label="All Files" />
      ) : (
        <UnselectedChip
          label="All Files"
          onClick={() => setFilterState(undefined)}
        />
      )}
      {filterState === FileTag.Rfp ? (
        <SelectedChip label="RFP" />
      ) : (
        <UnselectedChip
          label="RFP"
          onClick={() => setFilterState(FileTag.Rfp)}
        />
      )}
      {filterState === FileTag.Admin ? (
        <SelectedChip label="Admin" />
      ) : (
        <UnselectedChip
          label="Admin"
          onClick={() => setFilterState(FileTag.Admin)}
        />
      )}
      {filterState === FileTag.Training ? (
        <SelectedChip label="Training" />
      ) : (
        <UnselectedChip
          label="Training"
          onClick={() => setFilterState(FileTag.Training)}
        />
      )}
    </Stack>
  )
  //TODO: Replace with IconButtons when ready
  const inlineRightChildren = () => (
    <Box display="flex" justifyContent="flex-end">
      <FilePickerButton onFilesSelected={onFilesSelected} />
    </Box>
  )

  return (
    <>
      <PageSection
        header="Documents"
        inlineLeftChildren={inlineLeftChildren()}
        inlineRightChildren={inlineRightChildren()}
      >
        <DocumentsTable
          documentsTableData={
            filterState
              ? filter(documentsTableData, (row) => row.tag === filterState)
              : documentsTableData
          }
          deleteFile={deleteFile}
          editFile={editFile}
        />
      </PageSection>

      {isConsensus && (
        <PageSection header="Reports">
          <ReportsTable
            reportsTableData={reportsTableData}
            generateReport={generateReport}
          />
        </PageSection>
      )}
    </>
  )
}

const SelectedChip = ({ label }: { label: string }): JSX.Element => (
  <Chip
    label={
      <Typography variant="body2" color="info.light">
        {label}
      </Typography>
    }
    color="primary"
  />
)

const UnselectedChip = ({
  label,
  onClick,
}: {
  label: string
  onClick: () => void
}): JSX.Element => (
  <Chip
    label={<Typography variant="body2">{label}</Typography>}
    variant="outlined"
    onClick={onClick}
  />
)
